module.exports = __webpack_public_path__ + "static/media/error.fb14e9ad.png";